import { Wrench } from "lucide-react";
export function SetupPage() {
  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="notice-icon">
          <Wrench size={24} />
        </div>
        <h1>Estufa ainda não configurada</h1>
        <p>
          Defina <code>VITE_SUPABASE_URL</code> e <code>VITE_SUPABASE_ANON_KEY</code>, ou use{" "}
          <code>VITE_ESTUFA_DEMO_MODE=true</code> somente para revisão visual local.
        </p>
        <p>Nenhuma fixture será usada silenciosamente em produção.</p>
      </div>
    </div>
  );
}
